import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <div style={{background: '#ffffff'}}>
      <Helmet>
        <title>Cargo Engage - Financial Lead Generation & Marketing Services | A2P Compliant</title>
        <meta name="description" content="Professional lead generation and marketing services for financial service providers. Connect consumers with trusted lending partners through our TCPA and A2P 10DLC compliant platform." />
        <meta name="keywords" content="lead generation, financial services, SMS marketing, A2P 10DLC, TCPA compliant, lending leads, mortgage leads" />
      </Helmet>
      {/* Unique Hero Section - Split Design */}
      <section className="hero">
        <div className="container" style={{position: 'relative', zIndex: 1}}>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center', minHeight: '80vh'}}>
            
            {/* Left Side - Content */}
            <div>
              <div style={{display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: 'rgba(6, 182, 212, 0.1)', border: '1px solid rgba(6, 182, 212, 0.3)', borderRadius: '50px', marginBottom: '2rem', fontSize: '0.875rem', color: '#06b6d4'}}>
                <span style={{width: '8px', height: '8px', background: '#06b6d4', borderRadius: '50%', animation: 'pulse 2s ease-in-out infinite'}}></span>
                A2P 10DLC Registered & Compliant
              </div>
              
              <h1 style={{fontSize: '4.5rem', fontWeight: '800', lineHeight: '1.1', marginBottom: '1.5rem', fontFamily: 'Space Grotesk'}}>
                Financial Lead
                <br />
                <span style={{background: 'linear-gradient(135deg, #06b6d4, #0891b2)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'}}>
                  Generation
                </span>
                <br />
                Reimagined
              </h1>
              
              <p style={{fontSize: '1.25rem', color: 'rgba(255,255,255,0.7)', marginBottom: '2.5rem', lineHeight: '1.8'}}>
                Connect consumers with trusted financial service providers through our compliant, high-quality lead generation platform.
              </p>
              
              <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
                <Link to="/contact" style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '1rem 2rem',
                  background: 'linear-gradient(135deg, #06b6d4, #0891b2)',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '12px',
                  fontWeight: '600',
                  fontSize: '1.1rem',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 0 30px rgba(6, 182, 212, 0.3)'
                }}>
                  Get Started
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </Link>
                
                <Link to="/services" style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '1rem 2rem',
                  background: 'rgba(255,255,255,0.1)',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '12px',
                  fontWeight: '600',
                  fontSize: '1.1rem',
                  border: '1px solid rgba(255,255,255,0.2)',
                  transition: 'all 0.3s ease'
                }}>
                  Explore Services
                </Link>
              </div>
              
              {/* Stats Row */}
              <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2rem', marginTop: '4rem', paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.1)'}}>
                <div>
                  <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#06b6d4', marginBottom: '0.25rem'}}>5+</div>
                  <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.6)'}}>Years Experience</div>
                </div>
                <div>
                  <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#06b6d4', marginBottom: '0.25rem'}}>100%</div>
                  <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.6)'}}>TCPA Compliant</div>
                </div>
                <div>
                  <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#06b6d4', marginBottom: '0.25rem'}}>24/7</div>
                  <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.6)'}}>Lead Delivery</div>
                </div>
              </div>
            </div>
            
            {/* Right Side - 3D Illustration */}
            <div style={{position: 'relative'}}>
              {/* CSS Art - Abstract 3D Shape */}
              <div style={{position: 'relative', width: '100%', height: '600px'}}>
                {/* Main Circle */}
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: '400px',
                  height: '400px',
                  background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2), rgba(8, 145, 178, 0.1))',
                  borderRadius: '50%',
                  border: '2px solid rgba(6, 182, 212, 0.3)',
                  animation: 'float 6s ease-in-out infinite'
                }}></div>
                
                {/* Floating Cards */}
                <div style={{
                  position: 'absolute',
                  top: '20%',
                  right: '10%',
                  width: '180px',
                  padding: '1.5rem',
                  background: 'rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '16px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  animation: 'float 4s ease-in-out infinite'
                }}>
                  <div style={{fontSize: '2rem', marginBottom: '0.5rem'}}>📊</div>
                  <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.9)', fontWeight: '600'}}>Lead Analytics</div>
                  <div style={{fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)', marginTop: '0.25rem'}}>Real-time tracking</div>
                </div>
                
                <div style={{
                  position: 'absolute',
                  bottom: '15%',
                  left: '5%',
                  width: '180px',
                  padding: '1.5rem',
                  background: 'rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '16px',
                  border: '1px solid rgba(255,255,255,0.2)',
                  animation: 'float 5s ease-in-out infinite',
                  animationDelay: '1s'
                }}>
                  <div style={{fontSize: '2rem', marginBottom: '0.5rem'}}>🔒</div>
                  <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.9)', fontWeight: '600'}}>100% Secure</div>
                  <div style={{fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)', marginTop: '0.25rem'}}>TCPA Compliant</div>
                </div>
                
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  right: '20%',
                  width: '180px',
                  padding: '1.5rem',
                  background: 'rgba(6, 182, 212, 0.2)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '16px',
                  border: '1px solid rgba(6, 182, 212, 0.4)',
                  animation: 'float 4.5s ease-in-out infinite',
                  animationDelay: '0.5s'
                }}>
                  <div style={{fontSize: '2rem', marginBottom: '0.5rem'}}>⚡</div>
                  <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.9)', fontWeight: '600'}}>Instant Connect</div>
                  <div style={{fontSize: '0.75rem', color: 'rgba(255,255,255,0.6)', marginTop: '0.25rem'}}>Fast delivery</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Important Disclosure - Unique Design */}
      <section style={{background: '#fef3c7', padding: '2rem 0', borderTop: '3px solid #f59e0b', borderBottom: '3px solid #f59e0b'}}>
        <div className="container">
          <div style={{display: 'flex', alignItems: 'center', gap: '2rem', maxWidth: '1000px', margin: '0 auto'}}>
            <div style={{fontSize: '3rem', flexShrink: 0}}>⚠️</div>
            <div>
              <h3 style={{color: '#92400e', fontSize: '1.25rem', fontWeight: '700', marginBottom: '0.5rem'}}>Important Disclosure</h3>
              <p style={{color: '#78350f', fontSize: '1rem', lineHeight: '1.6', margin: 0}}>
                CARGO AUTOMOTIVE SERVICES INC (operating as Cargo Engage) is a <strong>lead generation and marketing company</strong>. We are <strong>NOT a lender</strong> and do <strong>NOT make credit decisions</strong>. 
                When you submit an inquiry, you authorize us to share your information with our network of financial service providers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Services - Unique Card Grid */}
      <section style={{padding: '6rem 0', background: '#f8fafc'}}>
        <div className="container">
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <div style={{display: 'inline-block', padding: '0.5rem 1rem', background: '#e0f2fe', color: '#0369a1', borderRadius: '50px', fontSize: '0.875rem', fontWeight: '600', marginBottom: '1rem'}}>
              Our Services
            </div>
            <h2 style={{fontSize: '3.5rem', fontWeight: '800', marginBottom: '1rem', fontFamily: 'Space Grotesk'}}>
              What We <span style={{color: '#06b6d4'}}>Deliver</span>
            </h2>
            <p style={{fontSize: '1.25rem', color: '#64748b', maxWidth: '600px', margin: '0 auto'}}>
              Comprehensive lead generation solutions for the financial services industry
            </p>
          </div>

          <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2rem'}}>
            {[
              {icon: '🎯', title: 'Lead Generation', desc: 'High-quality, verified leads for financial service providers', color: '#06b6d4'},
              {icon: '📱', title: 'SMS Marketing', desc: 'A2P 10DLC compliant text message campaigns', color: '#0891b2'},
              {icon: '✉️', title: 'Email Campaigns', desc: 'Professional email marketing with automation', color: '#0e7490'},
              {icon: '📊', title: 'Campaign Management', desc: 'Full-service management with ROI tracking', color: '#155e75'},
              {icon: '✅', title: 'Lead Qualification', desc: 'Advanced scoring and verification processes', color: '#164e63'},
              {icon: '🔒', title: 'Compliance First', desc: '100% TCPA, CTIA, and A2P compliant', color: '#083344'}
            ].map((service, index) => (
              <div key={index} style={{
                background: 'white',
                padding: '2.5rem',
                borderRadius: '20px',
                border: '1px solid #e2e8f0',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }} onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = service.color;
              }} onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = '#e2e8f0';
              }}>
                <div style={{fontSize: '3rem', marginBottom: '1rem'}}>{service.icon}</div>
                <h3 style={{fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: '#0f172a'}}>{service.title}</h3>
                <p style={{color: '#64748b', lineHeight: '1.6'}}>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section - Unique Design */}
      <section style={{padding: '6rem 0', background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', position: 'relative', overflow: 'hidden'}}>
        <div style={{position: 'absolute', top: '0', right: '0', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(6, 182, 212, 0.1) 0%, transparent 70%)', borderRadius: '50%'}}></div>
        <div className="container" style={{position: 'relative', zIndex: 1}}>
          <div style={{maxWidth: '800px', margin: '0 auto', textAlign: 'center'}}>
            <h2 style={{fontSize: '3.5rem', fontWeight: '800', color: 'white', marginBottom: '1.5rem', fontFamily: 'Space Grotesk'}}>
              Ready to Get Started?
            </h2>
            <p style={{fontSize: '1.25rem', color: 'rgba(255,255,255,0.7)', marginBottom: '3rem', lineHeight: '1.8'}}>
              Connect with trusted financial service providers through our compliant lead generation platform
            </p>
            <Link to="/contact" style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '1.25rem 3rem',
              background: 'linear-gradient(135deg, #06b6d4, #0891b2)',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '12px',
              fontWeight: '700',
              fontSize: '1.25rem',
              boxShadow: '0 0 40px rgba(6, 182, 212, 0.4)',
              transition: 'all 0.3s ease'
            }}>
              Request Information
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
